import { render, staticRenderFns } from "./AgregarEstudioDialogComponent.vue?vue&type=template&id=67747db3"
import script from "./AgregarEstudioDialogComponent.vue?vue&type=script&lang=js"
export * from "./AgregarEstudioDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports